import { loadConnectAndInitialize } from '@stripe/connect-js';
import {
  ConnectComponentsProvider,
  ConnectProductTaxCodeSelector,
} from '@stripe/react-connect-js';
import React, { useCallback, useState } from 'react';
import { Box } from 'src/components/Box';
import { useSession } from 'src/contexts/SessionContext';
import { fetchStripeAccountSession } from 'src/models/platform/platform';

interface StripeTaxCodesProps {
  initialTaxCode?: string | null;
  onTaxCodeSelect?: (taxCodeId: string | null) => void;
}

export const StripeTaxCodes: React.FC<StripeTaxCodesProps> = ({
  initialTaxCode = null,
  onTaxCodeSelect,
}) => {
  const { session } = useSession();

  const fetchClientSecret = useCallback(async () => {
    const response = await fetchStripeAccountSession({
      productTaxCodeSelector: true,
    });
    return response.clientSecret;
  }, []);

  const [stripeConnectInstance] = useState(() => {
    const publishableKey = session?.platformStripeToken;

    if (!publishableKey) {
      return null;
    }

    const params: any = {
      publishableKey,
      fetchClientSecret,
      appearance: {
        overlays: 'dialog',
      },
    };

    if (session?.theme?.primary) {
      params.appearance.variables = {
        colorPrimary: session.theme.primary,
      };
    }

    return loadConnectAndInitialize(params);
  });

  if (!stripeConnectInstance) {
    return null;
  }

  return (
    <Box>
      <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
        <ConnectProductTaxCodeSelector
          initialTaxCode={initialTaxCode || undefined}
          onTaxCodeSelect={onTaxCodeSelect}
        />
      </ConnectComponentsProvider>
    </Box>
  );
};
